import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function Level5Illustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3959" data-mp="ntwzxwub8aeb">
      <div className="relative w-full h-full bg-gradient-to-b from-green-200 to-emerald-400 overflow-hidden" data-id="element-3960" data-mp="xm319x6gc466">
        {/* Background: Garden/Nature */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3961" data-mp="1bl2i4inq3ers">
          {/* Bushes */}
          <circle cx="30" cy="140" r="40" fill="#22C55E" data-id="element-3962" data-mp="3dd7ec6c98y8b" />
          <circle cx="60" cy="150" r="35" fill="#16A34A" data-id="element-3963" data-mp="38ent685hjqh0" />
          <circle cx="170" cy="130" r="45" fill="#22C55E" data-id="element-3964" data-mp="38g8o3yvppbfe" />
          <circle cx="140" cy="150" r="30" fill="#16A34A" data-id="element-3965" data-mp="3fk6x2xuhaekj" />

          {/* Sun */}
          <circle cx="160" cy="40" r="25" fill="#FEF08A" data-id="element-3966" data-mp="3kj0eh1cvyppz" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[10%]" data-id="element-3967" data-mp="3pgs39mi8hvpy">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-3968" data-mp="3u8a84lndogg7">
            <DjaySpecimen look={{
            variant,
            accessory: 'leafGarland'
          }} size="hero" emotion={isUnlocked ? 'excited' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3969" data-mp="23zm63rgxrnx" />
          </div>
        </div>

        {/* Foreground: Leaves and Flowers */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3970" data-mp="2du1ujgkl5hgp">
            {/* Floating leaves */}
            <path d="M40 60 Q50 50 60 60 Q50 70 40 60 Z" fill="#86EFAC" transform="rotate(15 50 60)" data-id="element-3971" data-mp="2as5qz8auowp7" />
            <path d="M140 80 Q150 70 160 80 Q150 90 140 80 Z" fill="#4ADE80" transform="rotate(-25 150 80)" data-id="element-3972" data-mp="2kqd6dmphr6p3" />
            <path d="M20 100 Q30 90 40 100 Q30 110 20 100 Z" fill="#86EFAC" transform="rotate(45 30 100)" data-id="element-3973" data-mp="2ftcx72xchntr" />

            {/* Flowers */}
            <g transform="translate(30, 160) scale(0.5)" data-id="element-3974" data-mp="2opudekkkgbwd">
              <circle cx="0" cy="-10" r="8" fill="#F472B6" data-id="element-3975" data-mp="33f9pcuffucs0" />
              <circle cx="10" cy="0" r="8" fill="#F472B6" data-id="element-3976" data-mp="2yhrqxxz1rfy9" />
              <circle cx="0" cy="10" r="8" fill="#F472B6" data-id="element-3977" data-mp="2yi9u7ek4mufo" />
              <circle cx="-10" cy="0" r="8" fill="#F472B6" data-id="element-3978" data-mp="3cghotftoxjno" />
              <circle cx="0" cy="0" r="6" fill="#FDE047" data-id="element-3979" data-mp="3cewpze0cfek0" />
            </g>

            <g transform="translate(170, 170) scale(0.6)" data-id="element-3980" data-mp="38himm2zcg0zx">
              <circle cx="0" cy="-10" r="8" fill="#60A5FA" data-id="element-3981" data-mp="3r3q2qoedw33c" />
              <circle cx="10" cy="0" r="8" fill="#60A5FA" data-id="element-3982" data-mp="3r25a54bmqu84" />
              <circle cx="0" cy="10" r="8" fill="#60A5FA" data-id="element-3983" data-mp="3w1rojh372gii" />
              <circle cx="-10" cy="0" r="8" fill="#60A5FA" data-id="element-3984" data-mp="3i3jrl965rf7c" />
              <circle cx="0" cy="0" r="6" fill="#FDE047" data-id="element-3985" data-mp="3i307pmwy6gqo" />
            </g>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}